// ============================================================================
// SWAHILI TRANSLATIONS - CHAPTER 6: Misheni ya Paulo
// ============================================================================
// Viwango 66-78 (viwango 13, maswali 39)

export const chapter6Translations = {
  name: "Misheni ya Paulo",
  description: "Hadi miisho ya dunia...",
  
  spiritualWisdom: {
    principle: "Injili ni kwa mataifa yote na lazima ihubiriwe kwa ulimwengu wote",
    scripture: "Nendeni mkawafanye mataifa yote kuwa wanafunzi (Mathayo 28:19)",
    application: "Kila Mkristo ameitwa kushuhudia kwa Kristo mahali ambapo Mungu amemweka"
  },
  
  levels: {
    66: {
      name: "Safari ya Kwanza ya Kimisheni",
      challenge: "Nitengeeni Barnaba na Saulo kwa ajili ya kazi ambayo nimewaitia...",
      easy: {
        question: "Ni nani alifuatana na Paulo katika safari yake ya kwanza?",
        options: ["Petro", "Barnaba", "Sila", "Timotheo"],
        hint: "'Mwana wa Faraja'",
        funFact: "👥 Barnaba alimpokea Paulo baada ya tukio lake - ushirikiano wa kimungu!"
      },
      medium: {
        question: "Waliondoka kutoka mji gani kwa ajili ya ujumbe wao?",
        options: [
          "Yerusalemu",
          "Antiokia ya Syria",
          "Tarso",
          "Dameski"
        ],
        hint: "Jumuiya ya kwanza ya mchanganyiko ya Wayahudi na watu wa Mataifa",
        funFact: "🚢 Antiokia: bandari ya kuondoka kwa uevangelisti wa ulimwengu wa magharibi!"
      },
      hard: {
        question: "Safari hii ya kwanza inaonyesha nini kuhusu mkakati wa kimisheni?",
        options: [
          "Lazima ubaki katika eneo lako",
          "Injili inavuka mipaka yote ya kitamaduni",
          "Ni Wayahudi tu wanaweza kuokolewa",
          "Misheni ni hiari"
        ],
        hint: "Inazungumza kuhusu ujumla wa ujumbe",
        funFact: "🌊 Kuvuka Bahari ya Wastani = kuchukua hatua kwa uevangelisti wa kimataifa!"
      }
    },
    
    67: {
      name: "Huko Kipro na Elima",
      challenge: "Ewe uliye jaa hila zote na uovu wote, mwana wa shetani...",
      easy: {
        question: "Ni mchawi yupi aliyempinga Paulo huko Kipro?",
        options: ["Simoni", "Elima", "Apolo", "Aleksanderi"],
        hint: "Nabii wa uongo aliyetaka kumtenga gavana",
        funFact: "🪄 Mgongano wa kwanza wa moja kwa moja kati ya Injili na uchawi!"
      },
      medium: {
        question: "Paulo alimfanyia nini Elima kama adhabu?",
        options: [
          "Alimfukuza",
          "Alimpooza kwa muda",
          "Alimtelekeza",
          "Alibishana naye"
        ],
        hint: "Upofu wa muda ili kumfungua macho ya kiroho",
        funFact: "👁️ Kejeli ya Mungu: yule aliyewapooza roho anakuwa kipofu kwa muda!"
      },
      hard: {
        question: "Tukio hili linaonyesha vipi nguvu ya Injili?",
        options: [
          "Vurugu ni lazima",
          "Ukweli wa Mungu unashinda uongo",
          "Lazima upigane na wachawi wote",
          "Paulo alikuwa mlipiza kisasi"
        ],
        hint: "Inazungumza kuhusu mamlaka ya Mungu dhidi ya udanganyifu",
        funFact: "⚡ Gavana aliamini alipoona nguvu ya Mungu - onyesho lenye ufanisi!"
      }
    },

    68: {
      name: "Huko Antiokia ya Pisidia",
      challenge: "Kwenu kwanza ilipasa kuhubiriwa neno la Mungu...",
      easy: {
        question: "Paulo alihubiri wapi alipofika mjini?",
        options: [
          "Uwanjani wa umma",
          "Kwanza kwenye sinagogi",
          "Katika nyumba za matajiri",
          "Katika mahekalu ya kipagani"
        ],
        hint: "Alianza kila wakati na watu wake",
        funFact: "🕍 Mkakati wa kimisheni: kwanza kwa Wayahudi, kisha kwa Mataifa!"
      },
      medium: {
        question: "Wayahudi waliitikia vipi ujumbe wa Paulo?",
        options: [
          "Wote waliukubali",
          "Waligawanyika: wengine waliamini, wengine walipinga",
          "Walibaki bila kujali",
          "Walimfukuza mara moja"
        ],
        hint: "Mgawanyiko wa kawaida mbele ya Injili",
        funFact: "⚖️ Injili hugawanya kila wakati: ukubaliano au kukataa, si kutojali!"
      },
      hard: {
        question: "Kwa nini Paulo anaelekea kwa Mataifa?",
        options: [
          "Aliwapendelea Mataifa",
          "Kukataliwa na Wayahudi kunafungua mlango kwa mataifa",
          "Ilikuwa rahisi zaidi",
          "Aliacha ujumbe wake"
        ],
        hint: "Inazungumza kuhusu utimilifu wa unabii",
        funFact: "🚪 'Nuru kwa Mataifa' - unabii wa Isaya uliotimizwa na Paulo!"
      }
    },

    69: {
      name: "Uponyaji huko Listra",
      challenge: "Miungu katika sura ya wanadamu imeshuka kwetu!",
      easy: {
        question: "Paulo alimponya nani huko Listra?",
        options: [
          "Kipofu",
          "Kilema tangu kuzaliwa",
          "Kiziwi-bubu",
          "Mwenye ukoma"
        ],
        hint: "Mtu ambaye kamwe hakuwahi kutembea",
        funFact: "🦵 Muujiza wa kushangaza: 'Simama wima kwa miguu yako!' - imani inaponya!"
      },
      medium: {
        question: "Umati uliwafikiria Paulo na Barnaba kuwa nani?",
        options: [
          "Wafalme",
          "Miungu (Zeus na Herme)",
          "Wachawi",
          "Manabii"
        ],
        hint: "Miungu ya pantheon ya Kigiriki",
        funFact: "⚡ Barnaba = Zeus (maajabu), Paulo = Herme (msemaji) - kutofahamiana kwa kitamaduni!"
      },
      hard: {
        question: "Paulo aliitikia vipi ibada hii ya uongo?",
        options: [
          "Alikubali heshima",
          "Alirarua nguo zake na kuhubiri Mungu wa kweli",
          "Alikuwa kimya kwa heshima",
          "Alitumia hali hiyo"
        ],
        hint: "Kukataa kabisa sanamu",
        funFact: "👔 Kurarua nguo = hofu ya Kiyahudi mbele ya sanamu - uadilifu kamili!"
      }
    },

    70: {
      name: "Kupigwa Mawe na Kufufuka",
      challenge: "Wanafunzi walipomzunguka, aliinuka na kuingia mjini...",
      easy: {
        question: "Wenyeji wa Listra walimfanyia nini Paulo?",
        options: [
          "Walimfunga",
          "Walimpiga mawe",
          "Walimfukuza",
          "Walimsulubisha"
        ],
        hint: "Adhabu ya jadi ya Kiyahudi",
        funFact: "🪨 Kutoka 'mungu' hadi 'maiti' katika siku moja - kutofautiana kwa umati wa wanadamu!"
      },
      medium: {
        question: "Paulo alifanya nini baada ya kupigwa mawe?",
        options: [
          "Alikimbia mjini",
          "Alijificha",
          "Aliinuka na kurudi mjini",
          "Alienda hospitali"
        ],
        hint: "Ujasiri wa ajabu baada ya kifo kinachofikirika",
        funFact: "💪 Ufufuko wa muujiza au uponyaji wa Mungu - ujasiri wa kushangaza!"
      },
      hard: {
        question: "Mateso haya yanaonyesha nini kuhusu bei ya ushuhuda?",
        options: [
          "Lazima uepuke migogoro",
          "Kushuhudia kwa Kristo kunaweza kuwa na gharama ya maisha",
          "Paulo alikuwa haangalifu",
          "Mateso hayana faida"
        ],
        hint: "Inazungumza kuhusu gharama ya ushuhuda wa kweli",
        funFact: "✝️ 'Kwa mateso mengi lazima tuingie' - ukweli wa Paulo!"
      }
    },

    71: {
      name: "Baraza la Yerusalemu",
      challenge: "Kama hamtahiriwa, hamwezi kuokolewa...",
      easy: {
        question: "Mjadala gani muhimu ulifanyika katika Baraza la Yerusalemu?",
        options: [
          "Ubatizo",
          "Tohara ya Mataifa walioongoka",
          "Siku ya Sabato",
          "Sadaka"
        ],
        hint: "Je, ilipasa kuwa Myahudi ili kuwa Mkristo?",
        funFact: "✂️ Mgogoro mkubwa wa kwanza: Ukristo au Uyahudi-Ukristo?"
      },
      medium: {
        question: "Uamuzi wa mwisho wa baraza ulikuwa nini?",
        options: [
          "Tohara ya lazima",
          "Uhuru kwa Mataifa na mapendekezo machache",
          "Kutenganishwa kabisa na Wayahudi",
          "Kukataa uamuzi"
        ],
        hint: "Ufunguzi kwa Mataifa bila wajibu mkubwa",
        funFact: "🆓 Mapinduzi ya kihistoria: Injili imeachiwa huru kutoka sheria ya Mose!"
      },
      hard: {
        question: "Baraza hili lina umuhimu gani kwa Kanisa la kimataifa?",
        options: [
          "Tukio la pili",
          "Linaweka msingi wa ujumla wa wokovu kwa imani tu",
          "Linagawanya Kanisa",
          "Linaimarisha kisheria"
        ],
        hint: "Inazungumza kuhusu msingi wa Kanisa la kimataifa",
        funFact: "🌍 Bila uamuzi huu, Ukristo ungebaki kuwa sehemu ya Kiyahudi!"
      }
    },

    72: {
      name: "Safari ya Pili: Timotheo",
      challenge: "Paulo alitaka kumchukua naye na akamtahiri kwa sababu ya Wayahudi...",
      easy: {
        question: "Ni nani alijiunga na Paulo kama msaidizi mchanga?",
        options: ["Marko", "Luka", "Timotheo", "Tito"],
        hint: "'Mwana mpendwa' wa Paulo",
        funFact: "👦 Timotheo: kijana maajabu aliyekuwa mkono wa kulia wa Paulo - ufundishaji wenye mafanikio!"
      },
      medium: {
        question: "Kwa nini Paulo alimtahiri Timotheo licha ya uhuru uliofikiwa?",
        options: [
          "Kwa wajibu wa kisheria",
          "Kwa mkakati wa kimisheni kati ya Wayahudi",
          "Kwa jadi",
          "Kwa kosa"
        ],
        hint: "Hekima ya vitendo ili kuepuka vikwazo",
        funFact: "🎯 Uhuru na hekima: 'Kuwa kila kitu kwa kila mtu ili kuokoa wengine'!"
      },
      hard: {
        question: "Msimamo huu unaonyesha vipi unyumbufu wa kimisheni?",
        options: [
          "Paulo alikuwa haendani",
          "Alirekebisha mbinu yake bila kurekebisha Injili",
          "Alishindwa na shinikizo",
          "Alikuwa mnafiki"
        ],
        hint: "Inazungumza kuhusu hekima ya muktadha",
        funFact: "⚖️ Kanuni imara, mbinu zinazobadilika - sanaa ya ushuhuda wenye ufanisi!"
      }
    },

    73: {
      name: "Maono ya Mmakedoniya",
      challenge: "Vuka uje Makedoniya utusaidie!",
      easy: {
        question: "Paulo aliona nini katika ono lake la usiku?",
        options: [
          "Malaika",
          "Mmakedoniya akimwita",
          "Yesu akizungumza naye",
          "Nuru kuu"
        ],
        hint: "Wito wa msaada kutoka Ulaya",
        funFact: "🌉 Ono la maamuzi: Injili inavuka kwenda Ulaya - hatua muhimu katika historia!"
      },
      medium: {
        question: "Ulikuwa ni mji gani wa kwanza wa Ulaya uliohubiria?",
        options: [
          "Athene",
          "Korintho",
          "Filipi",
          "Thesalonike"
        ],
        hint: "Koloni ya Kirumi katika Makedonia",
        funFact: "🏛️ Filipi: jumuiya ya kwanza ya Ulaya - bara lilibadilishwa milele!"
      },
      hard: {
        question: "Ono hili linawakilisha nini kwa historia ya Ukristo?",
        options: [
          "Ndoto tu",
          "Kupanuka kwa kimungu magharibi",
          "Kijivuno",
          "Kubadilisha mpango"
        ],
        hint: "Inazungumza kuhusu Utawala unaongoza historia",
        funFact: "🗺️ Bila ono hili, Ulaya ingeweza kubaki kipagani - mpango wa Mungu!"
      }
    },

    74: {
      name: "Lidia, Mkristo wa Kwanza wa Ulaya",
      challenge: "Bwana akafungua moyo wa Lidia ili asikilize...",
      easy: {
        question: "Lidia alikuwa wa kazi gani?",
        options: [
          "Mwokaji",
          "Mfanyabiashara wa zambarau",
          "Mfumaji",
          "Mfinyanzi"
        ],
        hint: "Biashara ya anasa ya wakati huo",
        funFact: "🟣 Zambarau = rangi ya kifalme ya bei ghali sana - Lidia alikuwa mwenye ustawi!"
      },
      medium: {
        question: "Paulo alikutana na Lidia wapi?",
        options: [
          "Sokoni",
          "Kando ya mto wakati wa sala",
          "Nyumbani kwake",
          "Sinagogini"
        ],
        hint: "Mahali pa sala nje",
        funFact: "🏞️ Hapakuwa na sinagogi huko Filipi - sala kando ya maji kwa jadi!"
      },
      hard: {
        question: "Kuongoka kwa Lidia kunaonyesha nini kuhusu kazi ya Mungu?",
        options: [
          "Alikuwa tayari",
          "Mungu anafungua mioyo iliyoandaliwa kupokea neno lake",
          "Ilikuwa bahati",
          "Paulo alikuwa na ushawishi"
        ],
        hint: "Inazungumza kuhusu kitendo cha Mungu katika kuongoka",
        funFact: "💝 'Bwana akafungua moyo wake' - Mungu anaandaa na kufungua roho!"
      }
    },

    75: {
      name: "Gerezani huko Filipi",
      challenge: "Usiku wa manane Paulo na Sila waliomba na kuimba nyimbo za sifa kwa Mungu...",
      easy: {
        question: "Kwa nini Paulo na Sila walifungwa?",
        options: [
          "Wizi",
          "Kuvuruga amani kwa kufukuza pepo",
          "Kufuru",
          "Uasi"
        ],
        hint: "Uponyaji wa mtumwa wa kike aliyetabiri",
        funFact: "💸 Kukomboa roho kunagharimu watumia wake ghali - mateso ya kiuchumi!"
      },
      medium: {
        question: "Paulo na Sila walifanya nini gerezani?",
        options: [
          "Walilalamika",
          "Waliomba na kuimba",
          "Walitayarisha utetezi wao",
          "Walilala"
        ],
        hint: "Sifa licha ya minyororo",
        funFact: "🎵 Nyimbo za sifa usiku wa manane gerezani - imani isiyotikisika inayovutia!"
      },
      hard: {
        question: "Tabia yao ilibadilisha vipi hali?",
        options: [
          "Haikuwa na athari",
          "Ilimwongoa askari baada ya tetemeko la ardhi",
          "Iliwachukiza walinzi",
          "Iliwafanya wazimu"
        ],
        hint: "Ushuhuda wenye nguvu kwa mfano",
        funFact: "🌍 Tetemeko la ardhi + ushuhuda = kuongoka kwa askari na familia yake!"
      }
    },

    76: {
      name: "Huko Athene: Areopago",
      challenge: "Mnachomwabudu bila kumjua, huyo ndiye ninayemhubiri kwenu...",
      easy: {
        question: "Paulo alirejelea madhabahu gani huko Athene?",
        options: [
          "Kwa mungu Zeus",
          "Kwa Mungu Asiyejulikana",
          "Kwa Apollo",
          "Kwa Athena"
        ],
        hint: "Andiko la siri lililotumika kama sehemu ya kuanzia",
        funFact: "🏛️ 'Kwa Mungu Asiyejulikana' - sehemu ya mawasiliano ya kiakili na falsafa ya Kigiriki!"
      },
      medium: {
        question: "Paulo alihubiri mbele ya nani huko Athene?",
        options: [
          "Umati wa kawaida",
          "Wafilosofuki wa Kiepikirasi na Kistoiki huko Areopago",
          "Makuhani wa mahekalu",
          "Kaisari wa Kirumi"
        ],
        hint: "Wasomi wa hali ya juu wa Kigiriki",
        funFact: "🧠 Areopago = Harvard ya kale - Paulo mbele ya wanafikra wakubwa zaidi!"
      },
      hard: {
        question: "Majibu ya Waathene kuhusu ufufuo yalikuwa nini?",
        options: [
          "Kukubaliana kwa pamoja",
          "Mgawanyiko: dhihaka ya wengine, maslahi ya wengine",
          "Hasira ya jumla",
          "Kutojali kabisa"
        ],
        hint: "Majibu ya kawaida ya wasomi kwa siri hii",
        funFact: "🤔 Ufufuo = jiwe la kukwaza kwa akili ya binadamu yenye kiburi!"
      }
    },

    77: {
      name: "Korintho: Paulo Mfanyaji Hema",
      challenge: "Akabaki nao na kufanya kazi, kwa kuwa kwa uzalishi walikuwa wafanyaji hema...",
      easy: {
        question: "Paulo alifanya kazi gani ili ajitafutie?",
        options: [
          "Mvuvi",
          "Mfanyaji hema",
          "Mwandishi",
          "Mfanyabiashara"
        ],
        hint: "Ufundi alioujifunza",
        funFact: "⛺ Paulo: mtume-fundi - heshima ya kazi ya mikono kati ya Wakristo!"
      },
      medium: {
        question: "Paulo alikaa na nani huko Korintho?",
        options: [
          "Hotelini",
          "Na Akila na Prisila",
          "Na gavana",
          "Sinagogini"
        ],
        hint: "Wanandoa wafanyaji hema kama yeye",
        funFact: "👫 Akila na Prisila: wanandoa wa mfano wa kimisheni - ukarimu wa Kikristo!"
      },
      hard: {
        question: "Kwa nini Paulo alifanya kazi kwa mikono yake?",
        options: [
          "Kwa haja ya kiuchumi tu",
          "Ili asiwe mzigo na kuthibitisha ushuhuda wake",
          "Kwa jadi ya familia",
          "Kwa sababu alipenda ufundi huo"
        ],
        hint: "Inazungumza kuhusu uhuru na uaminifu",
        funFact: "💼 Uhuru wa kiuchumi = uhuru wa kuzungumza - Paulo hakuwa ategemea mtu yeyote!"
      }
    },

    78: {
      name: "Ghasia huko Efeso",
      challenge: "Mkuu ni Artemi wa Waefeso!",
      easy: {
        question: "Ni nani alichochea ghasia dhidi ya Paulo huko Efeso?",
        options: [
          "Mamlaka ya Kirumi",
          "Demetrio mfua dhahabu na wafanyakazi",
          "Wafilosofuki",
          "Makuhani wa Kiyahudi"
        ],
        hint: "Wale waliotengeneza mahekalu ya Artemi",
        funFact: "🏛️ Mgomo wa kwanza katika historia: Injili inatishia uchumi wa kipagani!"
      },
      medium: {
        question: "Paulo alifundisha muda gani huko Efeso?",
        options: [
          "Miezi 6",
          "Mwaka 1",
          "Miaka 2",
          "Miaka 3"
        ],
        hint: "Kukaa kwake kwa muda mrefu zaidi kwa misheni",
        funFact: "📅 Miaka 3 ya mafundisho makali - Efeso ikawa kitovu muhimu cha kimisheni!"
      },
      hard: {
        question: "Ghasia hizi zinaonyesha nini kuhusu athari ya kijamii ya Injili?",
        options: [
          "Injili haibadilishi chochote",
          "Inabadilisha miundo ya kiuchumi na kijamii",
          "Inagusa dini tu",
          "Inaepuka migogoro"
        ],
        hint: "Inazungumza kuhusu mabadiliko makubwa ya kijamii",
        funFact: "💰 Injili inaposonga mbele, sanamu zinapoteza soko lao - athari ya kiuchumi!"
      }
    }
  }
};

export default chapter6Translations;
